var React = require('react');

function UmbrellaOpen32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M32 13.806C32 14.842 31.138 16 29.984 16H17v10.963C17 29.74 14.745 32 11.973 32 9.185 32 7 29.803 7 27a1 1 0 1 1 2 0c0 1.682 1.306 3 2.973 3A3.036 3.036 0 0 0 15 26.963V16H2.016C.828 16 0 14.869 0 13.854 0 6.399 7.388 2.359 15 2.032V1a1 1 0 1 1 2 0v1.032c7.612.325 15 4.349 15 11.774zM16 4C10.372 4 2 6.624 2 13.854a.307.307 0 0 0 .104.164l13.852-.009c.015-.001.028-.009.044-.009.015 0 .028.008.044.009L29.9 14a.415.415 0 0 0 .1-.195C30 6.611 21.628 4 16 4z","key":1})]);
}

UmbrellaOpen32px.displayName = "UmbrellaOpen32px";

UmbrellaOpen32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};

module.exports = UmbrellaOpen32px;

UmbrellaOpen32px.default = UmbrellaOpen32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/umbrella-open-32px.svg
// module id = 1117
// module chunks = 0